import { Form } from 'antd';
import { Icon } from '@fuxi/eevee-icon';
import { MemberWrapper } from '../member-wrapper';
import { StepCompProps } from '../../add-member';
import BMIInfo from './BMIInfo';
import cx from './index.module.scss';

const BodyInfo = (props: StepCompProps) => {
  const { hidden, form } = props;

  return (
    <div className={cx('wrapper')}>
      <Form.Item
        hidden={hidden}
        labelAlign="right"
        name="bmiInfo"
        extra={
          <>
            <Icon name="tips" className={cx('tips-icon')} color="#00000040" />
            <span className={cx('tips-text')}>为提升人体识别确切性，优化顾客体感，请准确选择上述身体信息。</span>
          </>
        }
      >
        <MemberWrapper title="身体数据">
          <BMIInfo placeholder="请选择身高｜体重｜体脂率" />
        </MemberWrapper>
      </Form.Item>
    </div>
  );
};

export { BodyInfo };
